/**
 * We allow Bills to be sent to ERP in two ways:
 * the ERP bill can be based on GS bill effectiveDate or completionDate
 */
export const BILL_SYNC_DATE_SOURCE_OPT = [
  { id: 'effectiveDate', name: 'Effective Date' },
  { id: 'completionDate', name: 'Completion Date' },
]
